<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <form [formGroup]="form">
        <!-- Action for show notes -->
        @if (srNumber && srInprgoressAwating && !loadingSrDetail) {
        <app-validation-message
          type="info"
          [content]="{
            title: 'SECTION_NOTES' | translate,
            message: 'SECTION_NOTES_DESCRIPTION' | translate
          }"
          [showbutton]="false"
          [buttonText]="'VIEW_NOTES' | translate"
          (onBtnClick)="showNotes = true"
        />
        } @if(step >=1){ @if(isAmendmentCarnet || isReplaceCarnet ||
        isSubstituteCarnet){
        <section>
          @if(isAmendmentCarnet){
          <h1 class="section-heading">
            {{ "ATA_CARNET.MODIFY_CARNET_TITLE" | translate }}
          </h1>
          } @if(isReplaceCarnet){
          <h1 class="section-heading">
            {{ "ATA_CARNET.REPLACE_CARNET_TITLE" | translate }}
          </h1>
          <p class="px-2">
            {{ "ATA_CARNET.REPLACE_CARNET_INTRO_TEXT" | translate }}
          </p>
          } @if(isSubstituteCarnet){
          <h1 class="section-heading">
            {{ "ATA_CARNET.SUBSTITUTE_CARNET_TITLE" | translate }}
          </h1>
          <p class="px-2">
            {{ "ATA_CARNET.SUBSTITUTE_CARNET_INTRO_TEXT" | translate }}
          </p>
          }

          <div class="fields-container">
            <div class="field-control">
              <div class="field-control">
                <!-- info note -->
                <!-- <div class="field-control">
                  <app-validation-message
                    type="info"
                    [content]="{
                      title: 'ATA_CARNET.REFUND.NOTE_TITLE' | translate,
                      message: 'ATA_CARNET.REFUND.NOTE_TEXT' | translate
                    }"
                  />
                </div> -->
                <app-option-field
                  [control]="g('carnetNumber')"
                  [label]="'ATA_CARNET.CARNET_NO' | translate"
                  [options]="carnetNumberList"
                  [labelKey]="'Name'"
                  (onSelectionChange)="onCarnetChange($event)"
                  [loading]="loadingCarnetList"
                >
                </app-option-field>
              </div>
              @if(expiredCarnetMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'VALIDATION_MSG.CARNET_EXPIRED' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
              } @if(technicalErrorMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
              } @if(copyCarnetErrorMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: copyCarnetErrorMsg
                }"
                [showbutton]="false"
              ></app-validation-message>
              }
            </div>
          </div>
        </section>
        }
        <!-- @if(showATAHolderType || step >=2){
        <section>
          <h1 class="section-heading">
            {{ "ATA_CARNET.APPLICANT_TITLE" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [control]="g('holderType')"
                [label]="'ATA_CARNET.HOLDER_Q' | translate"
                [options]="applicantTypes"
                (onSelectionChange)="onHolderTypeChange($event)"
                [labelKey]="'Value'"
                [valueKey]="'Name'"
              >
              </app-boolean>
            </div>
          </div>
        </section>
        }  -->

        }
        <!-- sr deatil loader -->
        @if(loadingSrDetail){
        <app-skeleton-loader
          [formLoader]="true"
          [noOfFields]="5"
        ></app-skeleton-loader>
        }
        <ng-container>
          @if(!loadingSrDetail){ @if(step >=2){ @if(selectedMember &&
          selectedMember?.['Account Type Code'] != userType.MEMBER){
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.APPLICANT_TITLE" | translate }}
            </h1>

            <div class="fields-container">
              <div class="field-control">
                <app-boolean
                  [control]="form.get('hasOtherEmirateLicense')"
                  [options]="standardOption"
                  [label]="'ATA_CARNET.DOES_OTHER_EMIRATE_LICENSE' | translate"
                  (onSelectionChange)="setEmirateLicense($event)"
                />
              </div>
              @if (form.get('hasOtherEmirateLicense')?.value == fieldValue.YES
              || form.get('hasOtherEmirateLicense')?.value == fieldValue.YES_AR)
              {
              <div class="field-control">
                <app-option-field
                  [control]="g('otherEmirateName')"
                  [label]="'ATA_CARNET.OTHER_EMIRATE' | translate"
                  [lovType]="lookupKey.EMIRATES_TYPE"
                />
              </div>
              }
              <div class="field-control">
                <app-text-field
                  [control]="g('companNameEng')"
                  [label]="'ATA_CARNET.COMPANY_NAME' | translate"
                  [maxlength]="100"
                ></app-text-field>
              </div>
              <div class="field-control">
                <app-text-field
                  [control]="g('companNameAra')"
                  [label]="'ATA_CARNET.COMPANY_NAME_ARA' | translate"
                  [maxlength]="100"
                ></app-text-field>
              </div>
            </div>
          </section>
          }
          <!-- Contact info -->
          <section>
            <h2 class="section-heading">
              {{ "ATA_CARNET.CONTACT_TITLE" | translate }}
            </h2>
            <div class="fields-container">
              <div class="field-control">
                <app-text-field
                  [control]="g('contact.fullName')"
                  [label]="'ATA_CARNET.FullName' | translate"
                  [maxlength]="30"
                ></app-text-field>
              </div>
              <div class="field-control">
                <app-text-field
                  [control]="g('contact.email')"
                  [label]="'ATA_CARNET.Email' | translate"
                  [validationMessages]="{
                    email: 'VALIDATION_MSG.VALID_EMAIL' | translate
                  }"
                ></app-text-field>
              </div>
              <div class="field-control">
                <app-mobile-number
                  [control]="g('contact.mobile')"
                  [countryCodeControl]="g('contact.countryCode')"
                  [label]="'ATA_CARNET.Mobile' | translate"
                  [validationMessages]="{
                    mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                    uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                  }"
                />
              </div>
              <div class="field-control">
                <app-text-field
                  type="text"
                  [control]="g('contact.phone')"
                  [label]="'ATA_CARNET.Phone' | translate"
                  [validationMessages]="{
                    mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate
                  }"
                ></app-text-field>
              </div>
            </div>
          </section>

          <!-- Adding for someone else -->
          <!-- @if (g('holderType').value === 'Other') {
            @if(selectedMember && selectedMember?.['Account Type Code'] != UserType.MEMBER){
              <section>
                <h1 class="section-heading">
                  {{ "ATA_CARNET.COMPANY_TITLE" | translate }}
                </h1>
                <p class="ltr:pl-3">{{ "ATA_CARNET.COMPANY_DESC" | translate }}</p>
                <div class="fields-container">
                  <div class="field-control">
                    <app-text-field
                      [control]="g('company.name')"
                      [label]="'ATA_CARNET.COMPANY_NAME' | translate"
                    ></app-text-field>
                  </div>
                  <div class="field-control">
                    <app-mobile-number
                      [control]="g('company.mobile')"
                      [countryCodeControl]="g('company.countryCode')"
                      [label]="'ATA_CARNET.Mobile' | translate"
                      [validationMessages]="{
                        mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                        uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                      }"
                    />
                  </div>

                  <div class="field-control">
                    <app-text-field
                      type="text"
                      [control]="g('company.phone')"
                      [label]="'ATA_CARNET.Phone' | translate"
                      [validationMessages]="{
                        mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate
                      }"
                    ></app-text-field>
                  </div>           
                  
                </div>
              </section>
            }
            <section>
              <h1 class="section-heading">
                {{ "ATA_CARNET.REP_TITLE" | translate }}
              </h1>
              <p class="ltr:pl-3">{{ "ATA_CARNET.REP_DESC" | translate }}</p>
              <div class="fields-container">
                <div class="field-control">
                  <app-text-field
                    [control]="g('representative.fullName')"
                    [label]="'ATA_CARNET.FullName' | translate"
                  ></app-text-field>
                </div>
                <div class="field-control">
                  <app-text-field
                    [control]="g('representative.email')"
                    [label]="'ATA_CARNET.Email' | translate"
                    [validationMessages]="{
                      email: 'VALIDATION_MSG.VALID_EMAIL' | translate
                    }"
                  ></app-text-field>
                </div>
                <div class="field-control">
                  <app-mobile-number
                    [control]="g('representative.mobile')"
                    [countryCodeControl]="g('representative.countryCode')"
                    [label]="'ATA_CARNET.Mobile' | translate"
                    [validationMessages]="{
                      mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                      uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                    }"
                  />
                </div>
                <div class="field-control">
                  <app-text-field
                    type="text"
                    [control]="g('representative.phone')"
                    [label]="'ATA_CARNET.Phone' | translate"
                    [validationMessages]="{
                      mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate
                    }"
                  ></app-text-field>
                </div>
              </div>
            </section>
          }  -->
          }
          <!--Cargo information  ════-->
          @if(step >=3){
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.CARGO_INFO" | translate }}
            </h1>
            <div class="fields-container">
              <h2 class="text-xl font-bold mt-5 mb-5">
                {{ "ATA_CARNET.CARGO_PURPOSE_CURRENCY" | translate }}
              </h2>
              <div class="field-control">
                <app-option-field
                  [control]="g('cargo.purpose')"
                  [label]="'ATA_CARNET.PURPOSE' | translate"
                  [lovType]="lookupKey.INTENDED_GOODS"
                >
                </app-option-field>
              </div>
              <div class="field-control">
                <app-option-field
                  [control]="g('cargo.currency')"
                  [label]="'ATA_CARNET.CURRENCY' | translate"
                  [options]="currencyList"
                >
                </app-option-field>
              </div>
            </div>
          </section>
          }

          <!-- Add Products -->
          @if(step >=4){
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.TITLE_ADD_PRODUCT" | translate }}
            </h1>
            <p class="ltr:pl-3">
              {{ "ATA_CARNET.TITLE_ADD_PRODUCT_DESC" | translate }}
            </p>

            <div class="fields-container">
              <!-- Added Product list -->
              @if(products && products.length > 0){
              <section
                class="border border-dc-navy text-dc-navy divide-y divide-dc-navy"
              >
                @for (p of visibleProducts; track p) {
                <div class="relative p-3 sm:p-5 bg-white">
                  <h3 class="font-semibold text-sm sm:text-base mb-3">
                    {{ lang == "en" ? p.productNameEn : p.productNameAr }}
                  </h3>

                  <div class="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4">
                    <div>
                      <p class="text-xs sm:text-sm text-dc-navy!">
                        {{ "PRODUCT_LIST.HS_CODE" | translate }}
                      </p>
                      <p class="font-semibold text-dc-navy!">
                        {{ p.productHSCode ? p.productHSCode : "-" }}
                      </p>
                      <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                        {{ "PRODUCT_LIST.UNIT_PRICE" | translate }}
                      </p>
                      <p class="font-semibold text-dc-navy!">
                        {{ p.unitPrice | number : "1.2-2" }}
                      </p>
                    </div>
                    <div>
                      <p class="text-xs sm:text-sm text-dc-navy!">
                        {{ "PRODUCT_LIST.COUNTRY_OF_ORIGIN" | translate }}
                      </p>
                      <p class="font-semibold text-dc-navy!">{{ p.country }}</p>
                      <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                        {{ "PRODUCT_LIST.MEASUREMENT_UNIT" | translate }}
                      </p>
                      <p class="font-semibold text-dc-navy!">{{ p.unit }}</p>
                    </div>

                    <div>
                      <p class="text-xs sm:text-sm text-dc-navy!">
                        {{ "PRODUCT_LIST.QUANTITY" | translate }}
                      </p>
                      <p class="font-semibold text-dc-navy!">
                        {{ p.quantity | number }}
                      </p>
                      <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                        {{ "PRODUCT_LIST.WEIGHT" | translate }}
                      </p>
                      <p class="font-semibold text-dc-navy!">
                        {{ p.weight | number }}
                      </p>
                    </div>
                    @if (showActions && canAddEdit) {
                    <div
                      class="flex gap-4 justify-center text-dc-navy mb-3 sm:right-3 sm:mb-0"
                    >
                      <button
                        class="font-semibold underline"
                        (click)="editProduct(p)"
                      >
                        {{ "BUTTONS.EDIT" | translate }}
                      </button>
                      <button
                        class="hover:text-red-600 text-lg leading-none"
                        (click)="removeProduct(p)"
                        aria-label="Remove"
                      >
                        <i class="fas fa-remove"></i>
                      </button>
                    </div>
                    }@else {
                      <div class="flex items-center justify-center gap-2">
                             <a
                            class="text-dc-dark-blue font-semibold underline underline-offset-4 mr-4 cursor-pointer"
                            (click)="editProduct(p, 'view')"
                            >{{ "BUTTONS.VIEW" | translate }}</a
                          >
                      </div>
                    }
                  </div>
                </div>
                }

                <!-- pagination footer --->
                @if (products.length > 4) {
                <app-pagenation
                  [data]="{
                    currentPage: currentPage,
                    totalPages: totalPages,
                    totalItems: products.length
                  }"
                  (pageChangeEvent)="loadPage($event)"
                ></app-pagenation>
                }
              </section>
              } @if( form.get('products')?.touched &&
              form.get('products')?.hasError('required')){
              <div class="fields-error-container">
                <app-validation-message
                  [type]="'error'"
                  [content]="{
                    title: 'VALIDATION_MSG.ERROR' | translate,
                    message: 'VALIDATION_MSG.ADD_PRODUCT' | translate
                  }"
                  [showbutton]="false"
                ></app-validation-message>
              </div>
              }

              <div class="flex gap-2">
                @if (showActions && canAddEdit) {
                <app-button
                  classesName="btn-edge-cut"
                  [label]="'BUTTONS.ADD_PRODUCTS' | translate"
                  (onBtnClick)="addNewProduct()"
                >
                </app-button>
                } @if (products.length > 4 && showActions && canAddEdit) {
                  @if(showActions){
                  <app-button
                    type="button"
                    classesName="card-edge-cut-white btn-primary-small"
                    [label]="'BUTTONS.REMOVE_ALL_PRODUCTS' | translate"
                    (onBtnClick)="removeAllProducts()"
                  ></app-button>
                }
                
                <app-button
                  classesName="card-edge-cut-white"
                  [label]="'BUTTONS.VIEW_ALL_PRODUCTS' | translate"
                  (onBtnClick)="viewProductModal = true"
                >
                </app-button>
                 
                }
              </div>
            </div>
          </section>
          }
          <!--Travel details  -->
          @if(step >=5){
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.TRAVEL_TITLE" | translate }}
            </h1>
            <div class="fields-container">
              <div class="field-control">
                <label class="field-label">{{
                  "ATA_CARNET.CARNET_TYPE_Q" | translate
                }}</label>
                <div class="space-y-2">
                  @for ( option of typesOfCarnet; track option; let i = $index)
                  {
                  <div>
                    <div class="card-edge-cut relative border-blue">
                      <div class="card-body mb-5">
                        <div class="flex gap-5">
                          <label>
                            <input
                              type="radio"
                              [value]="option.value"
                              formControlName="carnetType"
                              class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
                              (change)="onCarnetTypeChange(option.value, true)"
                            />
                          </label>
                          <div class="text-dc-navy!">
                            <span class="flex w-full font-semibold">{{
                              option.label | translate
                            }}</span>
                            <span
                              class="w-full text-dc-navy! py-2"
                              [innerHTML]="
                                option.description
                                  | translate
                                    : {
                                        memberAmount: (50 | currency),
                                        nonMemberAmount: (100 | currency)
                                      }
                              "
                            >
                            </span>
                            @if (option?.information) {
                            <ul>
                              @for (info of option?.information; track info) {
                              <li class="py-2">
                                <span
                                  [innerHTML]="
                                    info.title
                                      | translate
                                        : {
                                            openCarnetAmount: '10500' | currency
                                          }
                                  "
                                ></span>
                              </li>
                              }
                            </ul>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  } 
                  @if ( form.get('carnetType')?.touched &&
                  form.get('carnetType')?.hasError('required')) {
                  <div class="fields-error-container">
                    {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                  </div>
                  }
                </div>
              </div>
              <!-- @if (g('carnetType').value == 'open') {
            <div class="field-control">
              <app-option-field
                [control]="g('counterfoils')"
                [label]="'ATA_CARNET.ADDITIOANL_COUNTERFOILS' | translate"
                [otherInfo]="
                  'ATA_CARNET.ADDITIOANL_COUNTERFOILS_DESC' | translate : 5
                "
                [placeholder]="'Select country'"
                [options]="[
                  { label: 'UAE', Value: 'ae' },
                  { label: 'IND', Value: 'in' }
                ]"
                [country]="true"
              >
              </app-option-field>
              <app-button
                classesName="btn-edge-cut"
                [label]="'BUTTONS.ACCEPT_CONTINUE' | translate"
                (onBtnClick)="(false)"
              >
              </app-button>
            </div>
            } -->
            </div>
          </section>

          @if (g('carnetType').value == 'regular') {
          <section>
            <div class="fields-container">
              <h2 class="text-xl font-bold mt-5 mb-5">
                {{ "ATA_CARNET.JOURNEY" | translate }}
              </h2>
              <p class="py-3">{{ "ATA_CARNET.JOURNEY_DESC" | translate }}</p>

              <!-- @if ( form.get('journeyDetails')?.touched &&
              form.get('journeyDetails')?.hasError('required')) {
              <div class="fields-error-container">
                {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
              </div>
              }  -->
              @if(addJourney || journeyList.length < 1 ){
              <div class="field-control">
                <app-option-field
                  [control]="g('journeyDestination')"
                  [label]="'ATA_CARNET.DEST_COUNTRY' | translate"
                  [lovType]="lookupKey.ATA_CARNET_COUNTRIES"
                ></app-option-field>
              </div>
              <div class="field-control">
                <app-option-field
                  [control]="g('journeyEntryType')"
                  [label]="'ATA_CARNET.ENTRY_TYPE' | translate"
                  [lovType]="lookupKey.ENTRY_TYPE"
                ></app-option-field>
              </div>
              <div class="field-control">
                <app-option-field
                  [control]="g('journeyTransportMode')"
                  [label]="'ATA_CARNET.MODE_OF_TRANSPORT' | translate"
                  [lovType]="lookupKey.MODE_OF_TRASNPORT"
                ></app-option-field>
              </div>

              <div class="field-control">
                <app-text-field
                  type="number"
                  [control]="g('visitCounterfoil')"
                  [label]="
                    'ATA_CARNET.ADDITIONAL_VISIT_COUNTERFOIL' | translate
                  "
                ></app-text-field>
              </div>

              <div class="field-control">
                <app-text-field
                  type="number"
                  [control]="g('transitCounterfoil')"
                  [label]="
                    'ATA_CARNET.ADDITIONAL_TRANSIT_COUNTERFOIL' | translate
                  "
                ></app-text-field>
              </div>
              <!--Transit Message -->
              @if (visitTransitErrorMsg) {
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'ALERT.ERROR' | translate,
                  message: validationMessageKey | translate
                }"
              >
              </app-validation-message>
              } @if( showActions && canAddEdit){
              <div class="flex flex-col sm:flex-row gap-2">
                @if(!editJourneyDetail){
                  <app-button
                    class="block w-full sm:w-auto"
                    type="button"
                    classesName="btn-edge-cut w-full sm:w-auto"
                    [label]="'BUTTONS.SAVE_ADD_ANOTHER' | translate"
                    (onBtnClick)="saveJourneyDetail(true); addJourney = true"
                  >
                  </app-button>
                }
                <app-button
                  class="block w-full sm:w-auto"
                  type="button"
                  classesName="card-edge-cut-white w-full sm:w-auto"
                  [label]="
                    editJourneyDetail != null
                      ? ('BUTTONS.UPDATE' | translate)
                      : ('BUTTONS.SAVE' | translate)
                  "
                  (onBtnClick)="saveJourneyDetail()"
                >
                </app-button>
                @if(journeyList.length > 0){ 
                  <app-button
                    class="block w-full sm:w-auto"
                    type="button"
                    classesName="card-edge-cut-white w-full sm:w-auto"
                    [label]="'BUTTONS.CANCEL' | translate"
                    (onBtnClick)="cancelTravelPlan()"
                  >
                  </app-button>
                }
              </div>
              } }
              <!-- card list -->
              <app-card-carousel
                [ownerList]="journeyList"
                [showActions]="showActions && canAddEdit"
                (onActionClick)="onTravelPlanEvent($event)"
                [cardFor]="'travelPlan'"
              />

              @if(!addJourney && showActions && canAddEdit){
              <div class="flex flex-col sm:flex-row gap-2">
                <app-button
                  class="block w-full sm:w-auto"
                  classesName="btn-edge-cut w-full sm:w-auto"
                  [label]="'BUTTONS.ADD_ANOTHER' | translate"
                  (onBtnClick)="addNewJourney()"
                >
                </app-button>
              </div>
              }
            </div>
          </section>
          }
          <!-- hide deposit for replace and subsitute -->
            @if (!isReplaceCarnet && !isSubstituteCarnet) {
              <section>
                <h2 class="text-xl font-bold mt-5 mb-5">
                  {{ "ATA_CARNET.SECURITY_DEPOSIT" | translate }}
                </h2>
                <p [innerHTML]="'ATA_CARNET.SECURITY_DEPOSIT_DESC' | translate"></p>
                @if(showDepositLoader){
                <app-skeleton-loader
                  [formLoader]="true"
                  [noOfFields]="2"
                ></app-skeleton-loader>
                } @if(!showDepositLoader){
                <app-validation-message
                  [type]="'info'"
                  [content]="{
                    title:
                      'ATA_CARNET.SECURITY_DEPOSIT_AMOUNT'
                      | translate : { amount: securityAmount | currency }
                  }"
                >
                </app-validation-message>
                }
              </section>
            }
            <!-- End deposit -->
          } 
          @if(step >=6){ @if(isSubstituteCarnet){
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.SUBSTITUTE_CARNET_REASON_TITLE" | translate }}
            </h1>
            <div class="fields-container">
              <div class="field-control">
                <app-text-field
                  [control]="g('substituteReason')"
                  [label]="'ATA_CARNET.SUBSTITUTE_REASON' | translate"
                  [maxlength]="500"
                >
                </app-text-field>
              </div>
            </div>
          </section>
          }

          <!--Processing & Collection  -->
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.PROCESS_TITLE" | translate }}
            </h1>
            <div class="fields-container">
              @if(!isAmendmentCarnet && !isReplaceCarnet &&
              !isSubstituteCarnet){
              <div class="field-control">
                <app-boolean
                  [control]="g('processingType')"
                  [label]="'ATA_CARNET.PROCESS_TYPE' | translate"
                  [options]="processTypes"
                  [labelKey]="'Value'"
                  [valueKey]="'Value'"
                >
                </app-boolean>
              </div>
              }
              <div class="field-control">
                <app-boolean
                  [control]="g('collectionType')"
                  [label]="'ATA_CARNET.COLLECTION' | translate"
                  [lovType]="lookupKey.ATA_CARNET_COLLECTION_TYPE"
                  [labelKey]="'Value'"
                  [valueKey]="'Value'"
                  (onSelectionChange)="onChangeCollectionType($event)"
                >
                </app-boolean>

                <!-- courier address fields -->
                @if (g('collectionType').value == fieldValue.COURIER_EN ||
                g('collectionType').value == fieldValue.COURIER_AR) {
                <div class="field-control">
                  <app-mobile-number
                    [control]="g('courier.mobile')"
                    [countryCodeControl]="g('courier.countryCode')"
                    [label]="'ATA_CARNET.Mobile' | translate"
                    [validationMessages]="{
                      mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                      uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                    }"
                  />
                </div>
                <div class="field-control">
                  <app-text-field
                    [control]="g('courier.email')"
                    [label]="'ATA_CARNET.COURIER_EMAIL' | translate"
                    [maxlength]="100"
                  />
                </div>
                <div class="field-control">
                  <app-text-field
                    [control]="g('courier.buildingUnit')"
                    [label]="'ATA_CARNET.BUILDING_UNIT' | translate"
                    [maxlength]="200"
                  />
                </div>
                <div class="field-control">
                  <app-text-field
                    [control]="g('courier.address')"
                    [label]="'ATA_CARNET.ADDRESS' | translate"
                    [maxlength]="500"
                  />
                </div>
                <div class="field-control">
                  <app-text-field
                    [control]="g('courier.area')"
                    [label]="'ATA_CARNET.AREA' | translate"
                    [maxlength]="100"
                  />
                </div>
                <div class="field-control">
                  <app-option-field
                    [control]="g('courier.emirate')"
                    [label]="'ATA_CARNET.EMIRATE' | translate"
                    [lovType]="lookupKey.EMIRATES_TYPE"
                  />
                </div>
                }

                <!-- message if collection = branch -->
                @if (g('collectionType').value == fieldValue.DCCI_BRANCH_EN ||
                g('collectionType').value == fieldValue.DCCI_BRANCH_AR) {
                <app-validation-message
                  type="info"
                  [content]="locationContent"
                  [buttonText]="'LOCATION.VIEW_MAP' | translate"
                  (onBtnClick)="viewOnMap()"
                ></app-validation-message>
                }

                <!-- end message -->
              </div>
            </div>
          </section>

          } @if(step >=7 && (!isSubstituteCarnet && !this.isReplaceCarnet)){
          <!--Uploads  -->
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.UPLOAD_TITLE" | translate }}
            </h1>
            <div class="px-2 hidden">
              <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
            </div>

            <div class="fields-container">
              @if(loadingDoc){
              <app-skeleton-loader
                [formLoader]="true"
                [noOfFields]="3"
              ></app-skeleton-loader>
              } @if (srFolder && !loadingDoc) { @for (dt of mainFromSectionDocs;
              track $index) {
              <div class="field-control">
                <app-file
                  #fileCmp
                  [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                  [control]=""
                  [documentType]="dt.nameEn"
                  (folderMissing)="openFolder()"
                  (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                  [showAction]="
                    dt.nameEn == fieldValue.DOCUMENT_PAYMENT_SLIP
                      ? true
                      : showActions
                  "
                  [folder]="srFolder"
                  [documentServiceType]="documentServiceType.ATA_CARNET"
                  [stampLocationRequirement]="dt?.stampLocationRequirement || 'NOT_APPLICABLE'"
                ></app-file>
              </div>
              } }
            </div>
          </section>
          }
          <!--T & C    ═-->
          @if(step >=6){
          <!-- section for payment method -->
          <section>
            <h1 class="section-heading">
              {{ "SECTION_PAYMENT_METHOD" | translate }}
            </h1>
            <div class="fields-container">
              <div class="field-control">
               <app-boolean
                  [label]="'PAYMENT_METHOD' | translate"
                  [control]="form.get('paymentMethod')!"
                  [lovType]="lookupKey.PAYMENT_METHOD"
                  [labelKey]="'Value'"
                  [valueKey]="'Value'"
                  (onSelectionChange)="onPaymentMethodChange($event)"
                />
              </div>
              @if ( noAdvancePaymentBalance) {
              <app-validation-message
                [content]="{
                  title: 'ALERT.ERROR' | translate,
                  message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
                }"
                type="error"
              />
              }
            </div>
          </section>
          }
          @if(step >=7){
          <section>
            <div class="fields-container">
              <div class="field-control">
                <label
                  class="flex items-center gap-5 lg:gap-x-2 cursor-pointer relative"
                >
                  <input
                    formControlName="agree"
                    type="checkbox"
                    class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
                  />
                  <span
                    class="h-6 w-6 font-sans text-white text-sm text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy"
                  >
                    <i class="fas fa-check"></i>
                  </span>
                  <span
                    class="text-sm text-dc-navy"
                    (click)="openTermsCondition()"
                    [innerHTML]="'ATA_CARNET.AGREEMENT' | translate"
                  ></span>
                </label>
                @if( form.get('agree')?.touched &&
                form.get('agree')?.hasError('required')){
                <div class="fields-error-container">
                  {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                </div>
                }
              </div>
            </div>
          </section>
          }
          <!-- Error Message -->
          @if(technicalErrorMsg){
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
            }"
            [showbutton]="false"
          ></app-validation-message>
          }
          
          @if (errorMsg || depositAmountError) {
          <app-validation-message
            [type]="'error'"           
            [content]="{
              title: 'ALERT.ERROR' | translate,
              message: errorMsg
                ? errorMsg
                : ('TOAST_MESSAGES.ATA_DEPOSIT_INCREASE' | translate)
            }"
          >
          </app-validation-message>
          }          
          <!--Action buttons   ═-->
          <!-- @if (invalidSummary.length) {
          <div class="fields-error-container mb-4">
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'VALIDATION_MSG.FILL_REQUIRED_FIELDS' | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            <ul class="list-disc ml-6 text-red-700">
              @for (f of invalidSummary; track $index) {
              <li>{{ f }}</li>
              }
            </ul>
          </div>
          } -->
          <div class="btn-section buttons-group">
            @if (showActions && !formSubmitLoader) {
            <app-button
              [type]="'button'"
              [label]="'BUTTONS.NEXT' | translate"
              classesName="btn-edge-cut  btn-width-auto"
              (onBtnClick)="nextStep()"
            />
            <!-- <app-button
            [type]="'button'"
            [label]="'BUTTONS.PREVIEW_FORM' | translate"
            classesName="card-edge-cut-white  btn-width-auto"
            (onBtnClick)="previewForm()"
          /> -->
            @if(step > 1){
            <app-button
              [type]="'button'"
              [label]="'BUTTONS.SAVE_CLOSE' | translate"
              classesName="card-edge-cut-white !btn-edge-cut btn-width-auto"
              (onBtnClick)="saveAndClose()"
            />
            } } @if(formSubmitLoader){
            <app-button
              type="button"
              classesName="btn-edge-cut btn-width-auto"
              [label]="'PLEASE_WAIT' | translate"
              [disabled]="true"
            ></app-button>
            }
          </div>
          }
        </ng-container>
      </form>
    </div>
  </div>
</div>

<div>
  <app-service-progress
    [serviceName]="serviceTitle | translate"
    [completePercentage]="formProgress"
  />
</div>

<!-- Add Product Modal -->
@if (addProductModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <!-- Close Button -->
    <button
      class="modal-x-button"
      type="button"
      (click)="addProductModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <!-- Modal Header -->
    <h1 class="section-heading">
      {{ selectedProductMode == 'add' ? ("ATA_CARNET.ADD_PRODUCT_FORM_TITLE" | translate) : ("PRODUCT_FORM.VIEW_TITLE" | translate) }}
    </h1>
    <p class="px-2">{{ "ATA_CARNET.ADD_PRODUCT_FORM_DESC" | translate }}</p>
     <app-add-carnet-product
      [(isOpen)]="addProductModal"
     [serviceName]="'ATA_CARNET'"
      [product]="selectedProduct"
      [MasterHsCodeList]="
        totalHsRecords == masterHSCodeList.length ? masterHSCodeList : []
      "
      (onBtnClick)="onProductSubmit($event)"
      [allowProductActions]="showActions && canAddEdit"
      [mode]="selectedProductMode"
    />
  </div>
</div>

} @if (viewProductModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <!-- Close Button -->
    <button
      class="modal-x-button"
      type="button"
      (click)="viewProductModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <!-- Modal Header -->
    <h1 class="section-heading">
      {{ "ATA_CARNET.ALL_PRODUCTS" | translate }}
    </h1>
    <app-add-carnet-product
      [(isOpen)]="viewProductModal"
      [serviceName]="'ATA_CARNET'"
      [viewProductList]="true"
      [allProducts]="products"
      [MasterHsCodeList]="masterHSCodeList"
      (onBtnClick)="onProductSubmit($event)"
      [allowProductActions]="showActions && canAddEdit"
    />
  </div>
</div>
} @if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
}

<!-- Consent modal -->
@if (termsModal) {
<app-digital-consent-modal
  [data]="consentModalData"
  (onSubmit)="submitPledge($event)"
></app-digital-consent-modal>
}
<!-- notes modal -->
@if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="showNotes = false"
></app-notes>
}
